import { getCookie } from "@/lib/utils/cookie"

export interface IAuthResponse {
  success: boolean
  message?: string
  redirectUrl?: string
}

export const authService = {
  getAuthToken(): string | undefined {
    return getCookie("auth-token") as string | undefined
  },

  isAuthenticated(): boolean {
    return !!this.getAuthToken()
  },

  requireAuth(redirectPath = "/auth/login/google"): IAuthResponse {
    if (!this.isAuthenticated()) {
      return {
        success: false,
        message: "Vui lòng đăng nhập để tiếp tục.",
        redirectUrl: redirectPath
      }
    }
    return { success: true }
  }
} 